import { render, staticRenderFns } from "./EditEmailTemplates.vue?vue&type=template&id=071ed0b5&scoped=true&"
import script from "./EditEmailTemplates.vue?vue&type=script&lang=js&"
export * from "./EditEmailTemplates.vue?vue&type=script&lang=js&"
import style0 from "./EditEmailTemplates.vue?vue&type=style&index=0&id=071ed0b5&scoped=true&lang=css&"
import style1 from "./EditEmailTemplates.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071ed0b5",
  null
  
)

component.options.__file = "EditEmailTemplates.vue"
export default component.exports